module.exports = __webpack_public_path__ + "img/chest.a5a4cd4f.png";